import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/bar';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/tooltip';

const yearly_data = [52, 54, 56, 59, 61, 38, 70, 68, 94, 94, 102, 108, 118, 67, 37];

class YearlyBarChart extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      startYear: 2005,
      endYear: 2019,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    if (parseInt(this.state.startYear) > parseInt(this.state.endYear)) {
      alert(`Invalid year range from ${this.state.startYear} to ${this.state.endYear}.`);
      return;
    } else {
      // update chart
      this.myChart.setOption({
        xAxis: [
          {
            data: Array.from({ length: parseInt(this.state.endYear - this.state.startYear) + 1 }, (_, i) => i + parseInt(this.state.startYear)),
          }
        ],
        series: [
          {
            data: yearly_data.slice(this.state.startYear - 2005, this.state.endYear - 2004)
          }
        ]
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = echarts.init(document.getElementById('yearly-bar-chart'), 'customColorTheme', 'EN');
    var option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: Array.from({ length: 15 }, (_, i) => i + 2005),
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: 'Yearly incidence',
          type: 'bar',
          barWidth: '75%',
          data: yearly_data.slice(this.state.startYear - 2005, this.state.endYear - 2004)
        }
      ]
    };
    this.myChart.setOption(option);
  }
  render() {
    var yearRange = Array.from({ length: 15 }, (_, i) => i + 2005);
    var startYearOptions = yearRange.map((x) => {
      if (x === this.state.startYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    var endYearOptions = yearRange.map((x) => {
      if (x === this.state.endYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    return (
      <>
        <form class="form-inline justify-content-center" style={{ 'margin-bottom': '30px' }}>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>Start Year</label>
            <select class="form-control" name="startYear" onChange={this.handleInputChange}>
              {startYearOptions}
            </select>
          </div>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>End Year</label>
            <select class="form-control" name="endYear" onChange={this.handleInputChange}>
              {endYearOptions}
            </select>
          </div>
          <button type="button" class="btn btn-outline-secondary" onClick={this.handleSubmit}>Submit</button>
        </form>
        <div class="m-auto" id="yearly-bar-chart" style={{ height: '400px' }}></div>
      </>
    );
  }
}

export default YearlyBarChart;